import { CookieStorage } from './CookieStorage';
import { LocalStorage } from './LocalStorage';
import { SessionStorage } from './SessionStorage';

export enum ClientStorageType {
  COOKIE_STORAGE = 'COOKIE_STORAGE',
  LOCAL_STORAGE = 'LOCAL_STORAGE',
  SESSION_STORAGE = 'SESSION_STORAGE'
}

export interface ClientStorage {
  set(key: string, value: any, ttl?: number): void;
  has(key: string): boolean;
  get(key: string): any;
  delete(key: string): void;
  refresh(key: string, ttl?: number): boolean;
}

export function ClientStorageFactory(type: ClientStorageType): ClientStorage {
  switch (type) {
    case ClientStorageType.COOKIE_STORAGE:
      return new CookieStorage();
    case ClientStorageType.LOCAL_STORAGE:
      return new LocalStorage();
    case ClientStorageType.SESSION_STORAGE:
      return new SessionStorage();
  }
}

class StorageSingleton implements ClientStorage {
  public set(key: string, value: any, ttl?: number): void {
    return this.instance().set(key, value, ttl);
  }

  public has(key: string): boolean {
    return this.instance().has(key);
  }

  public get(key: string): any {
    return this.instance().get(key);
  }

  public delete(key: string): void {
    return this.instance().delete(key);
  }

  public refresh(key: string, ttl?: number): boolean {
    return this.instance().refresh(key, ttl);
  }

  private storage: ClientStorage | null = null;

  private instance(): ClientStorage {
    return !!this.storage
      ? this.storage
      : (this.storage = ClientStorageFactory(
          process.env.REACT_APP_CLIENT_STORAGE
        ));
  }
}

const Session = new StorageSingleton();

export default Session;
